import { defineComponent } from "vue";
import { ClipboardDocumentCheckIcon } from "@heroicons/vue/24/outline";
export default defineComponent({
    components: {
        ClipboardDocumentCheckIcon,
    },
});
